import React from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DataGridToolbar = ({ 
  searchQuery, 
  onSearchChange, 
  onAddNew, 
  onBulkUpload, 
  onExport, 
  onDeleteSelected,
  onAIPriceFetch,
  selectedCount = 0,
  addLabel = "Add New",
  showBulkUpload = true,
  showExport = true,
  showAIPriceFetch = true
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 md:gap-4 p-4 md:p-6 bg-card border-b border-border">
      <div className="w-full sm:w-auto sm:flex-1 sm:max-w-md">
        <Input
          type="search"
          placeholder="Search records..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
      </div>
      <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
        {selectedCount > 0 && (
          <Button
            variant="destructive"
            size="sm"
            iconName="Trash2"
            iconPosition="left"
            onClick={onDeleteSelected}
          >
            Delete ({selectedCount})
          </Button>
        )}
        
        {showAIPriceFetch && (
          <Button
            variant="secondary"
            size="sm"
            iconName="Sparkles"
            iconPosition="left"
            onClick={onAIPriceFetch}
            className="bg-gradient-to-r from-primary/10 to-accent/10 hover:from-primary/20 hover:to-accent/20 border-primary/20"
          >
            <span className="hidden md:inline">AI Prices</span>
            <span className="md:hidden">AI</span>
          </Button>
        )}
        
        {showExport && (
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            <span className="hidden md:inline">Export</span>
          </Button>
        )}
        
        {showBulkUpload && (
          <Button
            variant="secondary"
            size="sm"
            iconName="Upload"
            iconPosition="left"
            onClick={onBulkUpload}
          >
            <span className="hidden md:inline">Import</span>
          </Button>
        )}
        
        <Button
          variant="default"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={onAddNew}
        >
          {addLabel}
        </Button>
      </div>
    </div>
  );
};

export default DataGridToolbar;